// extracted by mini-css-extract-plugin
export default {"whoWillPay":"yZmWBhwJ9UfcNSBvO3Nj","dollarIcon":"L2dyxq5ytp0Ffo4fOzO8","sectionTitle":"K4Dun1sfrYDf9notTi3A","pulse":"BBGiFpwAwQPepuaerYWc"};